/* ============================================================
   header.js — sticky scroll state + mobile drawer toggle
   Hooks: .header_main (the section wrapper), data-drawer, data-toggle="menu"
   ============================================================ */

(function () {
  const header = document.querySelector('.header_main');
  const drawer = document.querySelector('[data-drawer]');
  const toggles = document.querySelectorAll('[data-toggle="menu"]');
  if (!header) return;

  // ----- Sticky scroll state -------------------------------
  const isSticky = getComputedStyle(header).position === 'sticky';
  let lastY = 0;

  function onScroll() {
    if (!isSticky) return;
    const y = window.scrollY;
    header.classList.toggle('is-scrolled', y > 8);
    lastY = y;
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // ----- Mobile drawer -------------------------------------
  if (!drawer) return;

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    document.body.classList.add('is-drawer-open');
    toggles.forEach((t) => t.setAttribute('aria-expanded', 'true'));
    const firstLink = drawer.querySelector('a, button:not([tabindex="-1"])');
    if (firstLink) firstLink.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    document.body.classList.remove('is-drawer-open');
    toggles.forEach((t) => t.setAttribute('aria-expanded', 'false'));
  }

  function toggleDrawer() {
    if (drawer.classList.contains('is-open')) {
      closeDrawer();
    } else {
      openDrawer();
    }
  }

  toggles.forEach((t) => t.addEventListener('click', toggleDrawer));

  // Close on escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  // Close when leaving mobile breakpoint
  const debounce = (window.PEACHIES && window.PEACHIES.debounce) || function (fn, d) {
    let t;
    return function () { clearTimeout(t); t = setTimeout(fn, d || 150); };
  };
  window.addEventListener('resize', debounce(function () {
    const isMobile = window.PEACHIES ? window.PEACHIES.isMobile() : window.innerWidth < 768;
    if (!isMobile) closeDrawer();
  }, 150));
})();
